import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";

const { PRODUCT, PRICING, QUICK_CHECK, ABOUT, CONTACT, PRIVACY } = ROUTE_CONFIG;

const SITE_LINKS = [
	{ to: PRODUCT, key: "product" },
	{ to: PRICING, key: "pricing" },
	{ to: QUICK_CHECK, key: "quickCheck" },
	{ to: ABOUT, key: "about" },
	{ to: CONTACT, key: "contact" },
];

export function Footer({ className }: { className?: string }) {
	const { t } = useTranslation();

	return (
		<footer className="w-full bg-ink py-4 px-4 flex flex-col items-center justify-between gap-3 min-h-[50px] mt-auto">
			<div className="flex flex-wrap gap-x-6 gap-y-2 items-center justify-center">
				{SITE_LINKS.map((link) => (
					<Link
						key={link.key}
						className="font-urbanist font-medium text-[14px] leading-[150%] text-white/80 hover:text-white hover:underline"
						to={link.to}
					>
						{t(`marketing.footer.${link.key}`)}
					</Link>
				))}
			</div>
			<div className="flex gap-6 items-center justify-center">
				<a
					className="font-urbanist font-semibold text-[16px] leading-[150%] text-white hover:underline"
					href="https://www.maconia.de/impressum"
					rel="noreferrer noopener"
					target="_blank"
				>
					{t("questionnaire.landingCTASection.imprint")}
				</a>
				<Link
					className="font-urbanist font-semibold text-[16px] leading-[150%] text-white hover:underline"
					to={PRIVACY}
				>
					{t("questionnaire.landingCTASection.privacyPolicy")}
				</Link>
			</div>
			<p className="text-white text-xs justify-self-end ">
				{t("questionnaire.landingCTASection.copyright")}
			</p>
		</footer>
	);
}
